exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.main {\n  border: thin solid silver;\n  margin: 0.6ex;\n  padding: 0.6ex;\n}\n\ndiv.title {\n  font-weight: bold;\n  margin-bottom: 1ex;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/assigned-topic-box/assigned-topic-box.component.css
// module id = 379
// module chunks = 0